exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table .avatar[data-v-76d32e4c]{width:40px;height:40px;border-radius:50%;vertical-align:middle;-o-object-fit:cover;object-fit:cover}table tbody td.username span.el-tag[data-v-76d32e4c]{float:right}.pay[data-v-76d32e4c]{padding:0 10px}.pay li[data-v-76d32e4c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.pay li *[data-v-76d32e4c]:nth-child(2){font-weight:bold}.increase[data-v-76d32e4c]{color:#0abb87}.decrease[data-v-76d32e4c]{color:#c03639}", ""]);

// exports
